// What this server offers (GIF search, cloud backups, push…), from
// /api/v1/config, fetched once.
import { api } from "./api";

let cfg: Promise<Record<string, unknown>> | null = null;
export const serverConfig = () => (cfg ??= api.config().then((c): Record<string, unknown> => c as unknown as Record<string, unknown>, (): Record<string, unknown> => ({})));
